import React from 'react';
import classNames from 'classnames';
import useInteractiveAttributes from '../../hooks/use-interactive-handler';
import { BORDER_RADIUSES } from './constants';
const InteractiveBox = ({
  borderRadius = BORDER_RADIUSES.medium,
  selected = false,
  focusable = false,
  borderless = false,
  children,
  onClick = Function.prototype,
}) => {
  const classes = classNames(
    'ws-ui-interactive-box',
    `ws-ui-interactive-box--border-radius-${borderRadius}`,
    {
      'ws-ui-interactive-box--focusable': focusable,
      'ws-ui-interactive-box--selected': selected,
      'ws-ui-interactive-box--borderless': borderless,
    }
  );

  const interactiveAttributes = useInteractiveAttributes(onClick);

  return (
    // @ts-ignore TS(2322): Type '{ children: ReactNode | ReactNode[]; role?: ... Remove this comment to see the full error message
    <div className={classes} onClick={onClick} {...(focusable && interactiveAttributes)}>
      {children}
    </div>
  );
};

export default InteractiveBox;
